import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  // Header non impostabile da un form HTML cross-site: il backend lo richiede sugli upload
  // come difesa CSRF (la sessione vive in un cookie httpOnly).
  headers: { "X-Admin-Request": "1" },
});

export function mediaUrl(value) {
  if (!value) return null;
  if (value.startsWith("http")) return value;
  const path = value.startsWith("/") ? value : `/${value}`;
  // i path nudi dell'object storage vanno serviti da /api/files/
  return path.startsWith("/api/") ? `${BACKEND_URL}${path}` : `${BACKEND_URL}/api/files${path}`;
}

export function apiError(err, fallback = "Qualcosa è andato storto. Riprova.") {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message === "Network Error" ? "Connessione non disponibile." : fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (typeof e?.msg === "string" ? e.msg : "")).filter(Boolean).join(" ") || fallback;
  if (typeof detail?.msg === "string") return detail.msg;
  return fallback;
}
